<template>
    <div>
        <div class="auditable-status">
            <!--        <div v-if="isBlank" class="fa fa-minus text-muted"></div>-->
            <div v-if="isNotified" class="auditable-badge-notified">Notified</div>
            <div v-if="isPaid" class="auditable-badge-paid">Paid</div>
            <div v-if="isOnReview" class="auditable-badge-on-review">On Review</div>
            <div v-if="isScheduled" class="auditable-badge-scheduled">Scheduled</div>
            <div v-if="isCompleted" class="auditable-badge-pass">Pass</div>
            <div v-if="isFail" class="auditable-badge-fail">Fail</div>
        </div>
        <div v-if="(isCompleted || isFail) && auditableItem.completed_at" class="text-sm" v-text="shortDate(auditableItem.completed_at)"></div>
    </div>
</template>

<script>
    export default {

        props: {
            auditableItem: {
                type: Object,
                required: true,
            }
        },

        computed:{

            isBlank(){
                return this.auditableItem.notified_at == null &&
                this.auditableItem.status == null;
            },

            isNotified(){
                return this.auditableItem.notified_at != null &&
                       this.auditableItem.status == null &&
                        this.auditableItem.paid_at == null;
            },

            isPaid() {
                return this.auditableItem.notified_at != null &&
                    this.auditableItem.paid_at != null &&
                    this.auditableItem.review_at == null &&
                    (this.auditableItem.scheduled_at ? (this.auditableItem.scheduled_at == null) : true) &&
                    this.auditableItem.status == null;
            },

            isScheduled(){
                return this.auditableItem.notified_at != null &&
                    this.auditableItem.paid_at != null &&
                    this.auditableItem.review_at == null &&
                    (this.auditableItem.scheduled_at ? (this.auditableItem.scheduled_at != null) : false) &&
                    this.auditableItem.status == null;
            },

            isOnReview() {
                return this.auditableItem.notified_at != null &&
                    this.auditableItem.paid_at != null &&
                    this.auditableItem.review_at != null &&
                    (this.auditableItem.scheduled_at ? (this.auditableItem.scheduled_at != null) : true) &&
                    this.auditableItem.status == null;
            },

            isCompleted(){
                return this.auditableItem.status == 'pass';
            },

            isFail(){
                return this.auditableItem.status == 'fail';
            }
        }
    }
</script>
